import { Button, Flex, List, Typography } from 'antd';

import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import style from './topActivityCategories.module.scss';

/**
 * Минимальная форма для отрисовки: покрывает и топ по CRM (`TopActivityCategory`),
 * и произвольный список вроде категорий базового товара.
 */
export type TTopActivityCategory = {
    id: number;
    name: string;
    parents?: { id?: number; name: string }[];
};

type TProps = {
    categories: TTopActivityCategory[];
    /** Уже выбранные категории — из них берётся подсветка */
    selected: { id: number }[];
    onSelect: (category: TTopActivityCategory) => void;
    title?: string;
};

/**
 * Блок «Часто используемые» над полным списком категорий деятельности.
 *
 * Ничего не грузит сам: список приходит из `useTopActivityCategories`, а выбор
 * хранит владелец — тот же, что держит выбор в основном списке, иначе две
 * половины экрана расходились бы в том, что считается выбранным.
 */
export const TopActivityCategories = ({
    categories,
    selected,
    onSelect,
    title = 'Часто используемые',
}: TProps) => {
    if (categories.length === 0) return null;

    return (
        <>
            <div className={style.title}>{title}</div>
            <List
                className={`product-category-card-list ${style.list}`}
                dataSource={categories}
                itemLayout="horizontal"
                renderItem={(item) => {
                    const isSelected = selected.some((category) => category.id === item.id);

                    return (
                        <List.Item
                            className={`product-category-card ${style.item}`}
                            onClick={() => onSelect(item)}
                            data-selected={isSelected}
                        >
                            <Flex align="center" justify="space-between" style={{ width: '100%' }}>
                                <div>
                                    <h3 className="title" style={{ margin: 0 }}>
                                        {item.name}
                                    </h3>
                                    {item.parents?.length > 0 && (
                                        <Typography.Text type="secondary">
                                            {item.parents.map((parent) => parent.name).join(' / ')}
                                        </Typography.Text>
                                    )}
                                </div>
                                <Button
                                    icon={<FontAwesomeIcon icon={faCheck} />}
                                    shape="circle"
                                    type={isSelected ? 'primary' : 'default'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onSelect(item);
                                    }}
                                />
                            </Flex>
                        </List.Item>
                    );
                }}
            />
        </>
    );
};
